import React from 'react';
import Icon from '../Icon';
import styles from './index.module.scss';

export interface LoadingProps {
    className?: string;
    style?: React.CSSProperties;
    size?: number;
    color?: string;
}

const Loading = ({
    className = '', style, size = 16, color
}: LoadingProps) => {
    return (
        <div className={`${styles.loadingDots} ${className}`} style={style}>
            <Icon name="loading" size={size} color={color} />
        </div>
    );
};

export default Loading; 